function latRad(lat: number) {
    const sin = Math.sin(lat * Math.PI / 180);
    const radX2 = Math.log((1 + sin) / (1 - sin)) / 2;
    return Math.max(Math.min(radX2, Math.PI), -Math.PI) / 2;
}

function zoom(mapPx: number, worldPx: number, fraction: number) {
    return Math.floor(Math.log(mapPx / worldPx / fraction) / Math.LN2);
}

/**
* Calcula o nível de zoom ideal para exibir uma área delimitada (bounding box) no mapa
* 
* @param bbox - Objeto contendo as coordenadas dos limites da área (top, left, bottom, right)
* @param mapWidthPx - Largura do mapa em pixels
* @param mapHeightPx - Altura do mapa em pixels
* @returns Nível de zoom calculado (entre 0 e ZOOM_MAX)
* 
* O cálculo é feito convertendo as coordenadas geográficas para radianos e depois
* calculando a fração que a área ocupa em relação ao mundo todo, tanto em latitude
* quanto em longitude. Com base nisso e nas dimensões do mapa, calcula o zoom adequado
* para que a área caiba perfeitamente na visualização.
*/
export const getZoomForBounds = (bbox: { top: number; left: number; bottom: number; right: number }, mapWidthPx: number, mapHeightPx: number) => {
    const WORLD_DIM = { height: 256, width: 256 };
    const ZOOM_MAX = 18;

    const latFraction = (latRad(bbox.top) - latRad(bbox.bottom)) / Math.PI;
    const lngDiff = bbox.right - bbox.left;
    const lngFraction = ((lngDiff < 0 ? lngDiff + 360 : lngDiff) / 360);
    const latZoom = zoom(mapHeightPx, WORLD_DIM.height, latFraction);
    const lngZoom = zoom(mapWidthPx, WORLD_DIM.width, lngFraction);
    return Math.min(latZoom, lngZoom, ZOOM_MAX);
}